import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    '& div:first-child': {
      //marginTop: 0
    }
  },

  viewOption: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    height: 33,
    '& label': {
      cursor: 'pointer'
    }
  },

  header: {
    display: 'flex'
  },

  summaryContainer: {
    minHeight: 44,
    display: 'flex',
    alignItems: 'center',
    padding: '0px 16px'
  },

  count: {
    marginLeft: '8px'
  },

  selected: {
    color: theme.palette.primary.main,

    '& label': {}
  }
}))

export default useStyles
